import { useMutation } from '@tanstack/react-query';
import { trackError } from '@proposify/frontend-observability';
import { useTranslation } from 'react-i18next';
import { openNotification } from 'components/notification';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';
import { useInvalidateApprovalQueries } from 'hooks/useInvalidateApprovalQueries';

type ApproveDocumentMutationVariables = {
  contentId: string;
  notes?: string;
};

export const useApproveDocumentMutation = () => {
  const { t } = useTranslation();
  const invalidateApprovalQueries = useInvalidateApprovalQueries('useApproveDocumentMutation');

  return useMutation<void, unknown, ApproveDocumentMutationVariables>({
    mutationFn: async ({ contentId, notes }) => {
      try {
        await apiDocumentServiceRepository.approveDocument(contentId, { notes });
      } catch (error) {
        trackError(error, { tags: { module: 'useApproveDocumentMutation' }, extra: { contentId } });
        throw error;
      }
    },
    onSuccess: (_data, { contentId }) => {
      void invalidateApprovalQueries(contentId);
      openNotification({ type: 'success', title: t('share_document_v3.approve_document_menu.success') });
    },
    onError: () => {
      openNotification({ type: 'error', title: t('share_document_v3.approve_document_menu.error') });
    },
  });
};
